module.exports = __webpack_public_path__ + "static/media/Logout.900b15b0.svg";